import cx from 'classnames'
import { Button } from '@/components/Button'
import { IconButton } from '@/components/IconButton'
import {
  SubmissionSection,
  SubmissionSectionHeader,
} from '@/features/jobs/drafting/components/JobCreation/Submission/SubmissionSection'
import styles from './CouponSelection.module.css'

export interface CouponSelectionCoupon {
  code: string
  description?: string | null
}

export interface CouponSelectionProps {
  selectedCoupon: CouponSelectionCoupon | null
  isDisabled: boolean
  isRemovePending: boolean
  onShow: () => unknown
  onRemove: () => unknown
  compact?: boolean
  testId?: string
}

export function CouponSelection({
  selectedCoupon,
  isDisabled,
  isRemovePending,
  onShow,
  onRemove,
  compact,
  testId,
}: CouponSelectionProps) {
  return (
    <SubmissionSection compact={compact}>
      {selectedCoupon ? (
        <>
          <SubmissionSectionHeader label="Applied Coupon" compact={compact}>
            <Button
              label="Change"
              size={compact ? 'normal' : 'baseline'}
              variant="text"
              onPress={onShow}
              isDisabled={isDisabled}
            />
          </SubmissionSectionHeader>
          <SelectedCoupon
            coupon={selectedCoupon}
            isDisabled={isDisabled}
            isRemovePending={isRemovePending}
            onRemove={onRemove}
            compact={compact}
            testId={testId}
          />
        </>
      ) : (
        <div className={cx(styles.addCoupon, compact && styles.compact)}>
          <Button
            label="I have a coupon"
            block
            variant="text"
            onPress={onShow}
            isDisabled={isDisabled}
            testId={testId && `${testId}-add-coupon-button`}
          />
        </div>
      )}
    </SubmissionSection>
  )
}

interface SelectedCouponProps {
  coupon: CouponSelectionCoupon
  isDisabled: boolean
  isRemovePending: boolean
  onRemove: () => unknown
  compact?: boolean
  testId?: string
}

function SelectedCoupon({
  coupon,
  isDisabled,
  isRemovePending,
  onRemove,
  compact,
  testId,
}: SelectedCouponProps) {
  return (
    <div className={cx(styles.selectedCoupon, compact && styles.compact)}>
      <div className={styles.selectedCouponInfo}>
        <div
          className={styles.selectedCouponTitle}
          data-test={testId && `${testId}-selected-coupon-code`}
        >
          {coupon.code}
        </div>
        {coupon.description && (
          <div className={styles.selectedCouponDescription}>
            {coupon.description}
          </div>
        )}
      </div>
      <div className={styles.selectedCouponActions}>
        <IconButton
          name="close"
          label="Remove coupon"
          variant="ghost"
          onPress={onRemove}
          isDisabled={isDisabled}
          isPending={isRemovePending}
          testId={testId && `${testId}-remove-selected-coupon`}
        />
      </div>
    </div>
  )
}
